import React, { useEffect, useMemo, useState } from 'react'
import "./MarketSliderNews.css"
import { Navigation,A11y, Autoplay, EffectFade, EffectCreative, EffectCards, EffectFlip, EffectCube } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-creative';
import axios from 'axios';
// import axios from 'axios';
const dataz = [
   
  {
      name: "Bitcon",
      image :"https://res.cloudinary.com/wandia/image/upload/v1673603230/bitcoin-3732876_960_720_nb1fdk.jpg"
  },
  {
    name: "Etherium",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673603211/Ethereum-Best-place-to-stake-Ethereum_mnm0hp.jpg"
  },
  {
    name: "BNB ",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673603191/76d361b47a5c77573874e0c8471ed9fb_qfyak3.jpg"
  },
  {
    name: "Polkadot",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673603171/Can-Buying-Polkadot-DOT-and-Xchange-Monster-MXCH-Now-Make-You-a-Crypto-Millionaire_ewigs6.jpg"

   },
  {
      name: "Cardano",
      image :"https://res.cloudinary.com/wandia/image/upload/v1673603153/cardano-1280x720-1_u5qtbd.jpg"
  },
  {
    name: "Solana",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673603121/Solana-5_dvgjin.jpg"
  },
   {
    name: "Kadena",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673603250/hmiyx55cnhksa9thaoeo.png"
  },
  {
    name: "Litecoin",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673602955/shutterstock_709036540-5bfc32f246e0fb00514633ea_gdyeha.jpg"
  },
  {
    name: "DogeCoin",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673602934/robinhood-ceo-best-friend-dogecoin_vf386n.jpg"
  },
  {
    name: "Metaverse",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673602898/Best-Metaverse-Crypto-That-Can-Outperform-Bitcoin-In-2022_hke4go.jpg"
  }
  ,
  {
    name: "Gala",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673602871/CP_Altcoins_-GALA_1140x570_t6t9t7.jpg"
  },
  {
    name: "Matic",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673602850/Polygon_logo_resized.jpeg_cnmu5i.jpg"
  },
  {
    name: "CRO",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673602831/CRO-Crypto-Price-Prediction_e4qusb.jpg"
  },
  {
    name: "XRP",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673602809/Ripple-1_cgdenf.png"
  },
  {
    name: "Algo",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673602788/algorand-_ybzkjq.png"
  },
  {
    name: "Rune",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673602763/ThorChainLogo_rultav.jpg"
  },
  {
    name: "AXS",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673602740/22003_hlj9dx.jpg"
  },
  {
    name: "Tron",
    image :"https://zipmex.com/static/0e85266359c199a39ebc9bac8cabae34/1bbe7/TRX-price-prediction.jpg"
  },
  {
    name: "Aave",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673602717/ce-este-aave-criptomonede-romania-780x507_ofdvuz.jpg"
  },
  {
    name: "Uni",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673602661/uniswap-news_wjdkhe.jpg"
  },
  {
    name: "VeCHAIN",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673602638/Vechain-price-prediction_wy5mmt.jpg"
  },
  {
    name: "Avalance",
    image :"https://res.cloudinary.com/wandia/image/upload/v1673602586/These-5-Facts-About-Bitgert-BRISE-Are-Attracting-Solana-Holders_yofkxh.jpg"
  },
  ,
  {
    name: "Telegram @xcrxwadda || 254742845204",
    image :"https://wallpaper.dog/large/990949.jpg"
  }
  
]

function MarketSliderNews() {

  const memoizedValue = useMemo(() => dataz, [dataz])


  return (
    <div className='MarketSliderNews'>
         <Swiper
            // install Swiper modules
            modules={[Navigation,Autoplay,EffectCreative , A11y]}
            spaceBetween={50}
            slidesPerView={1}
            navigation
            effect=' Creative'
            disableOnInteraction="true"
            loop
            autoplay={{delay: 5000}}
         >
        <div className='MarketSliderNews_container'>
           {memoizedValue?.map((item)=> 
        <SwiperSlide className='slider'>
                <div className='slider_container'>
                    <div className='news_description'>
                        <p>{item.name}</p>
                    </div>
                        <img  loading='lazy' className='lazy_images' src={item?.image} alt="" />
                </div>
        </SwiperSlide>
            )}
        </div>
        </Swiper>
    </div>
  )
}

export default MarketSliderNews
